import { getHeaderHeight } from './getHeaderHeight';

export const scrollToElement = $element => {
  $('html, body').animate({ scrollTop: $element.offset().top - getHeaderHeight() - 20 }, 400);
};
